import { render, staticRenderFns } from "./DatabaseLanguages.vue?vue&type=template&id=f2de5098&scoped=true&"
import script from "./DatabaseLanguages.vue?vue&type=script&lang=js&"
export * from "./DatabaseLanguages.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseLanguages.vue?vue&type=style&index=0&id=f2de5098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2de5098",
  null
  
)

export default component.exports